const SESSION_KEY = 'puton-session';
const TOKEN_COOKIE = 'puton_token';

function getCookie(name) {
  if (typeof document === 'undefined') return '';
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : '';
}

function setTokenCookie(token) {
  if (typeof document === 'undefined') return;
  // Session cookie (no Max-Age) — cleared when browser session ends; cleared with site data
  document.cookie = `${TOKEN_COOKIE}=${encodeURIComponent(token)}; path=/; SameSite=Lax`;
}

function clearTokenCookie() {
  if (typeof document === 'undefined') return;
  document.cookie = `${TOKEN_COOKIE}=; path=/; Max-Age=0; SameSite=Lax`;
}

/** One-time migration for sessions saved before tokens existed */
function migrateLegacySession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return;
    const s = JSON.parse(raw);
    if (s?.loggedIn && !s.token) {
      const token = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({ ...s, token }));
      setTokenCookie(token);
      window.dispatchEvent(new Event('puton-auth-changed'));
    }
  } catch (_) {}
}

export function setSession(email) {
  try {
    const token = crypto.randomUUID();
    sessionStorage.setItem(
      SESSION_KEY,
      JSON.stringify({ email, loggedIn: true, token, at: Date.now() })
    );
    setTokenCookie(token);
    window.dispatchEvent(new Event('puton-auth-changed'));
  } catch (_) {}
}

export function getSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/**
 * Logged in for this browser session: sessionStorage holds a token; cookie mirrors it.
 * Cleared when the tab/window session ends or when site data / cache is cleared.
 */
export function isLoggedIn() {
  migrateLegacySession();
  const s = getSession();
  if (!s?.loggedIn || !s?.token) return false;
  const cookieTok = getCookie(TOKEN_COOKIE);
  if (cookieTok && cookieTok !== s.token) return false;
  if (!cookieTok) setTokenCookie(s.token);
  return true;
}

export function getAuthToken() {
  return getSession()?.token ?? null;
}

export function clearSession() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
    clearTokenCookie();
    window.dispatchEvent(new Event('puton-auth-changed'));
  } catch (_) {}
}
